import ChapterListTable from 'routes/ChapterList/ChapterListTable/ChapterListTable';

export default ChapterListTable;
